// extracted by mini-css-extract-plugin
module.exports = {"link":"entity_infos_lawyer-module__link--3_OlC"};